import { applyPosthogConsent } from '../../../services/posthogConsent'
import { getCurrentLegalDocumentActionStatuses } from './legalDocumentApi'
import {
  areLegalDocumentTypesAgreed,
  LEGAL_ACTION_CONTEXT,
  POSTHOG_DOCUMENT_TYPES,
} from '../lib/legalDocuments'

export async function syncPosthogConsentFromServer() {
  try {
    const result = await getCurrentLegalDocumentActionStatuses(
      LEGAL_ACTION_CONTEXT.CONSENT_MANAGEMENT,
    )
    const statuses = result.data?.legalDocumentActionStatuses || []
    const enabled = areLegalDocumentTypesAgreed(statuses, POSTHOG_DOCUMENT_TYPES)
    applyPosthogConsent(enabled)
    return enabled
  } catch (error) {
    applyPosthogConsent(false)
    throw error
  }
}
